/* eslint-disable */

import React from 'react';
import { Routes, Route } from 'react-router-dom';

import RefferenceParcel from './RefferenceParcel.js';
import RefferenceFactor from './RefferenceFactor.js';

function Refference(props) {
  return (
    <Routes>
      <Route
        path='/parcel'
        element={
          <RefferenceParcel app_hostname={props.app_hostname} permitdata={props.permitdata} />
        }
      />
      <Route
        path='/factor'
        element={
          <RefferenceFactor app_hostname={props.app_hostname} permitdata={props.permitdata} />
        }
      />
    </Routes>
  );
}

export default Refference;
